module.exports = __webpack_public_path__ + "img/MoneyManagement.eeb2f5cf.svg";